import {
  assertInInjectionContext,
  computed,
  DestroyRef,
  inject,
  Injectable,
  Signal,
  signal,
} from "@angular/core";

@Injectable({ providedIn: "root" })
export class GlobalLoadingFacade {
  private readonly sources = signal<readonly Signal<boolean>[]>([]);

  public readonly isLoading = computed<boolean>(() =>
    this.sources().some((source) => source())
  );

  public register(...sources: Signal<boolean>[]): void {
    assertInInjectionContext(this.register);

    const destroyRef = inject(DestroyRef);

    this.sources.update((current) => [...current, ...sources]);

    destroyRef.onDestroy(() => {
      this.sources.update((current) =>
        current.filter((source) => !sources.includes(source))
      );
    });
  }
}
